import React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";

const HeaderLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "grey.100",
      }}
    >
      <CssBaseline />
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "64px", // ヘッダーの高さ分を空ける
          p: 3,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default HeaderLayout;
